import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationSection from './ConfirmationSection';

const ConfirmationServicePay = ({ formData }) => {
  const answer = formData?.serviceInformation?.isReceivingServicePay;
  if (typeof answer !== 'boolean') return null;

  return (
    <ConfirmationSection
      title="Service pay"
      rows={[
        {
          label:
            'Are you receiving service pay now or will you receive it in the future?',
          value: answer ? 'Yes' : 'No',
        },
      ]}
    />
  );
};

ConfirmationServicePay.propTypes = {
  formData: PropTypes.shape({
    serviceInformation: PropTypes.shape({
      isReceivingServicePay: PropTypes.bool,
    }),
  }),
};

export default ConfirmationServicePay;
